import { useRef, useState } from 'react';

const GENERATING_PHRASES = [
  'Generating...',
  'Brewing...',
  'Cooking...',
  'Crunching...',
  'Phrasing...',
  'Wording...',
  'Crafting...',
  'Composing...',
  'Drafting...',
  'Shaping...',
  'Forming...',
  'Molding...',
  'Sketching...',
  'Whipping up...',
  'Conjuring...',
  'Stirring...',
];

/**
 * Returns a random placeholder phrase while generating, or the provided
 * default placeholder when idle. A new phrase is picked each time generation starts.
 */
export function useGeneratingPlaceholder(isGenerating: boolean, defaultPlaceholder: string): string {
  const [phrase, setPhrase] = useState('');
  const wasGenerating = useRef(false);

  if (isGenerating && !wasGenerating.current) {
    const next = GENERATING_PHRASES[Math.floor(Math.random() * GENERATING_PHRASES.length)];
    setPhrase(next);
    wasGenerating.current = true;
    return next;
  }

  if (!isGenerating) {
    wasGenerating.current = false;
  }

  return isGenerating ? phrase : defaultPlaceholder;
}
